"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormInputType = void 0;
var FormInputType;
(function (FormInputType) {
    FormInputType["UUID"] = "UUID";
    FormInputType["USERNAME"] = "USERNAME";
    FormInputType["EMAIL"] = "EMAIL";
    FormInputType["FIRST_NAME"] = "FIRST_NAME";
    FormInputType["LAST_NAME"] = "LAST_NAME";
    FormInputType["FULL_NAME"] = "FULL_NAME";
    FormInputType["COMPANY"] = "COMPANY";
    FormInputType["PHONE"] = "PHONE";
    FormInputType["AGE"] = "AGE";
    FormInputType["GENDER"] = "GENDER";
    FormInputType["BIRTHDAY"] = "BIRTHDAY";
    FormInputType["ADDRESS"] = "ADDRESS";
    FormInputType["COUNTRY"] = "COUNTRY";
    FormInputType["CITY"] = "CITY";
    FormInputType["ZIP_CODE"] = "ZIP_CODE";
    FormInputType["SRC"] = "SRC";
    FormInputType["BUSINESS_REGION"] = "BUSINESS_REGION";
    FormInputType["OTHER1"] = "OTHER1";
    FormInputType["OTHER2"] = "OTHER2";
    FormInputType["OTHER3"] = "OTHER3";
    FormInputType["OTHER4"] = "OTHER4";
    FormInputType["CONSENT"] = "CONSENT";
    FormInputType["CONSENT_MANDATORY"] = "CONSENT_MANDATORY";
    FormInputType["PARAM1"] = "PARAM1";
    FormInputType["PARAM2"] = "PARAM2";
    FormInputType["PARAM3"] = "PARAM3";
    FormInputType["PARAM4"] = "PARAM4";
    FormInputType["PARAM5"] = "PARAM5";
    FormInputType["PARAM6"] = "PARAM6";
    FormInputType["PARAM7"] = "PARAM7";
    FormInputType["PARAM8"] = "PARAM8";
    FormInputType["PARAM9"] = "PARAM9";
    FormInputType["PARAM10"] = "PARAM10";
})(FormInputType || (exports.FormInputType = FormInputType = {}));
